import axios from "axios";

export const sendAudio = async (blob) => {
  const formData = new FormData();
  formData.append("audio", blob, "recording.webm");

  //const res = await axios.post("https://192.168.1.67:5000/voice", formData);
  const res = await axios.post("https://beta.wordsworthlab.com:5000/voice", formData);
  return res.data;
};